"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * User class to hold all properties and methods related to a single user.
 */
var User =
/**
 * Constructor.
 *
 * @param {Object} data User object returned from the RedHawk API
 * @param {String} id value
 */
function User() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  _classCallCheck(this, User);

  this.id = id;
  this.type = data.type;
  this.name = data.name;
  this.email = data.email;
  this.isGuest = !data.email || data.email === 'None';
};
/**
 * Exports the User class.
 */


var _default = User;
exports["default"] = _default;